<script setup lang="ts"></script>

<template>
  <div class="background" data-testid="background">
    <slot />
  </div>
</template>

<style scoped>
  .background {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
  }
</style>